import UserSignUp from '../../../components/Signup/UserSignUp';

export default function SignUp() {
  return (
    <main className="flex min-h-screen flex-col items-center">
      <section className="z-10 max-w-5xl w-full items-center justify-between font-mono text-sm lg:flex">
        <UserSignUp />
      </section>
    </main>
  );
}
